import { createSlice } from "@reduxjs/toolkit";
import { GetAllRoleList } from "./RoleApi";

const RoleSlice = createSlice({
  name: "role",
  initialState: {
    roleListData: [],
    singleRoleData: null,
  },
  reducers: {
    setIndividualRole: (state, action) => {
      state.singleRoleData = action.payload;
    },
    resetIndividualRole: (state, _) => {
      state.singleRoleData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetAllRoleList.fulfilled, (state, action) => {
      state.roleListData = action.payload?.data?.role_details;
    });
  },
});

export const { setIndividualRole, resetIndividualRole } = RoleSlice.actions;
export default RoleSlice.reducer;
